<script setup>
useCustomMeta('top', '')
const mapName = 'japan'
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : [{ text: 'ゴルフ場の天気' }]
</script>

<template>
  <div>
    <NuxtLayout
      name="top"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <GolfMap
          :map-name="mapName"
          :map-data="areaToPrefTable"
        />
      </div>
      <template #main-center>
        <GolfSearch />
        <GolfLog />
      </template>
      <template #main-bottom>
        <GolfRecommend />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
